module.exports = __webpack_public_path__ + "img/preloader.9008acb2.png";